/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const split_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m20.25 20.998 3-3-3-3m3 3L18 18c-3.75 0-6.75-6-6.75-6m9-3.002 3-3-3-3m3 3L18 6c-3.75 0-6.75 6-6.75 6m0 0-10.5-.002"
    />
  </svg>
)
export default split_medium
